import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { PasswordProtectedComponent } from './password-protected/password-protected.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';
import {ConnectionComponent} from './connection/connection.component';

@NgModule({
  declarations: [HeaderComponent, PasswordProtectedComponent,ConnectionComponent],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    TranslateModule.forChild()
  ],
  exports: [
    HeaderComponent,
    PasswordProtectedComponent,
    TranslateModule,
    CommonModule,
    ConnectionComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
